import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CourseDetail81 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>Android詳細課程內容:</span>
        </h2>
        <p>
          課程內容除了設計模式、Kotlin語法之外，也會包含四個實用的Android應用程式專案。
        </p>
        <p>
          這些專案將涵蓋不同領域，包含繪圖軟體、重力五子棋遊戲、圖片搜尋App與圖書館資料庫管理：
          重力五子棋遊戲包含單人模式可與AI對戰，以及雙人遊玩模式。
          繪圖軟體提供聲音控制介面，可接收人類語言指令，並且根據指令自動操作。此外，繪圖軟體也提供顏色變換、橡皮擦模式、畫筆模式與填充模式等功能，並且使用者能夠儲存作品。
          圖片搜尋App連結網路API，將即時資料呈現給使用者。利用網絡API來獲取和顯示圖片。你將學習如何使用HTTP請求、解析JSON數據和展示圖片結果。
          圖書館資料庫管理提供借還書功能，並將數據儲存入資料庫內。
        </p>
      </motion.div>
    </div>
  );
};

export default CourseDetail81;
